<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle1"><a id="page_7">THE CONFESSIONS</a></p><a id="page_7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fm01.vue?016f3c9a